module.exports = __webpack_public_path__ + "static/media/bath.878cf492.svg";